module.exports = __webpack_public_path__ + "img/ic-upload.a0afcee4.svg";